<template>
	<TeamingDropDown
		:class="classes"
		:disabled="disabled"
		:options="options"
		:value="value"
		v-on="bubble( 'change', 'opening', 'opened', 'closing', 'closed' )"
	/>
</template>

<script>
import EventsMixin from "../mixins/EventsMixin";
import { TeamRoleType } from "@teaming/common-enums";
import TeamingDropDown from "./TeamingDropDown";
export default {
	name: "TeamRoleDropdown",
	emits: [ "change", "opening", "opened", "closing", "closed", ],
	mixins: [ EventsMixin, ],
	components: {
		TeamingDropDown,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		value: {
			type: String,
			required: true,
		},
	},
	computed: {
		classes() {
			return `team-role-dropdown ${ this.className }`.trim();
		},
		/**
		 * Array.<Object.<text:String, value:String>>
		 */
		options() {
			const { $t, } = this;
			return [
				{
					text: $t( `common.TeamRoleDropdown_${ TeamRoleType.LEAD }Option` ),
					value: TeamRoleType.LEAD,
				},
				{
					text: $t( `common.TeamRoleDropdown_${ TeamRoleType.MEMBER }Option` ),
					value: TeamRoleType.MEMBER,
				},
			];
		},
	},
};
</script>
